import { styled } from "../../../styles";

export const ModalBodyText = styled("p", {
  fontFamily: "$openSans",
  fontSize: "14px",
  color: "$charcoal",
  margin: 0,

  "& strong": {
    fontWeight: 700,
  },
});

/** Per-run counts returned by the tenant-ID sync. */
export const SyncResultList = styled("ul", {
  margin: 0,
  paddingLeft: "18px",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  fontFamily: "$openSans",
  fontSize: "13px",
  color: "$charcoal",
});
